import toast, { type ToastOptions } from "react-hot-toast";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const defaultSuccessToastOptions: ToastOptions = {
  position: "top-right",
  icon: <IoMdCheckmarkCircleOutline size={25} />,
  style: {
    background: " rgba(246, 254, 249, 1)",
    color: "rgba(2, 122, 72, 1)",
    border: "1px solid rgba(108, 233, 166, 1)",
    boxShadow: "0px 4px 6px -2px rgba(16, 24, 40, 0.03) 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
  },
};

export function showSuccessToast(message: string, options?: ToastOptions) {
  toast.success(message, { ...defaultSuccessToastOptions, ...options });
}

const defaultErrorToastOptions: ToastOptions = {
  position: "top-right",
  duration: 10000,
  style: {
    background: "rgba(255, 235, 238, 1)",
    color: "rgba(211, 47, 47, 1)",
    border: "1px solid rgba(244, 67, 54, 1)",
    boxShadow: "0px 4px 6px -2px rgba(16, 24, 40, 0.03) 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
  },
};

export function showErrorToast(message: string, options?: ToastOptions) {
  toast.error(message, { ...defaultErrorToastOptions, ...options });
}
